<template>
  <div class="user-links">
    <Links :type="$store.getters.userType" />
  </div>
</template>

<script>
import UserDropdown from './user-dropdown';
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';

export default {
  components: {
    Links: {
      functional: true,

      props: {
        type: {
          type: String,
          default: () => '',
        },
      },

      components: {
        UserDropdown,
      },

      data() {
        return {
          eventTracker,
          analyticsEvents,
        };
      },

      render(h, ctx) {
        const hasHolidayPromo = ctx.parent.$store.getters.hasHolidayPromo;
        if (ctx.props.type === 'paid') {
          let upgradeBtn = null;
          if (ctx.parent.$store.getters.hasContinuityPlan) {
            upgradeBtn = (
              <a
                href={hasHolidayPromo ? "/pricing/" : "/account/subscription/"}
                class="ml-5 cta"
                style={{
                  background: hasHolidayPromo && 'linear-gradient(180deg, #00278D 0%, #0094EB 100%)',
                }}
                onClick={() => {
                  eventTracker(analyticsEvents.clickOnUpgrade, { source: 'header' });
                }}>
                {hasHolidayPromo ? 'Upgrade Now' : 'Upgrade'}
              </a>
            );
          }
          return [upgradeBtn, <UserDropdown />];
        } else if (ctx.props.type === 'free') {
          return [
            <a
              href="/pricing/"
              class="m5-auto cta"
              onClick={() => {
                eventTracker(analyticsEvents.clickOnGetALicense, {
                  source: 'top nav',
                  button_name: 'Get a license',
                });
              }}>
              Get a License
            </a>,

            <UserDropdown />,
          ];
        }

        return [
          <a
            href="/pricing/"
            class="cta"
            onClick={evt => {
              evt.preventDefault();
              ctx.parent.$store.dispatch('setOpenSignUpModal', {
                open: true,
                clickSource: 'main navigation',
                buttonName: 'Start Free Now',
              });
              eventTracker(analyticsEvents.clickStartFreeTrial, {
                source: 'header',
                button_name: 'Start Free Now',
              });
            }}>
            Start Free Now
          </a>,
          <a
            href="/account/login/"
            class="flex items-center h-full text-primary-gray hover:text-white"
            onClick={evt => {
              evt.preventDefault();
              ctx.parent.$store.dispatch('setOpenSignInModal', {
                open: true,
                clickSource: 'main navigation',
                buttonName: 'Sign In',
              });
            }}>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 .75C5.766.75.75 5.813.75 12c0 6.234 5.016 11.25 11.25 11.25 6.188 0 11.25-5.016 11.25-11.25C23.25 5.812 18.187.75 12 .75zM12 6c1.828 0 3.375 1.547 3.375 3.375 0 1.875-1.547 3.375-3.375 3.375a3.361 3.361 0 01-3.375-3.375C8.625 7.547 10.125 6 12 6zm0 14.25a8.203 8.203 0 01-6.281-2.86C6.609 15.985 8.156 15 9.984 15h3.985c1.828 0 3.375.984 4.265 2.39-1.547 1.782-3.75 2.86-6.234 2.86z"
                fill="currentColor"
              />
            </svg>

            <div style="margin-left: 8px;">Sign In</div>
          </a>,
        ];
      },
    },
  },
};
</script>

<style scoped>
.user-links {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.user-links > * + * {
  margin-left: 20px;
}

.cta {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 27px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 8px;

  @apply bg-primary-green text-primary-purple;

  font-size: 12px;
  font-weight: 700;
}
</style>
